
// Chart loader Component
import chartLoaderTemplate from '../../common/views/progress-loader.html';

class CommonChart {
  constructor($scope, $mdMedia, $mdDialog, COMMON_CHART_CONSTANTS) {
    'ngInject';

    $scope.isLoadCompleted = true
    $scope.dialogObj = undefined

    $scope.getRandomString = function () {
      var letters = '0123456789ABCDEF';
      var chartId = 'id';
      for (var i = 0; i < 6; i++) {
        chartId += letters[Math.floor(Math.random() * 16)];
      }
      return chartId;
    }

    $scope.loadChartId = function () {
      return $scope.chart_id = $scope.getRandomString();
    }

    this.$onInit = function () {
      var graphHeight = this.graphHeight;
      var graphWidth = this.graphWidth;
      var graphType = this.chartType;
      var title = this.header;
      var subTitle = this.subTitle;
      var axis = this.axis;
      $scope.graphdata = this.graphData;
      var totlaItems = this.totalCount
      var currentItem = this.count
      var colors = this.colors
      var names = this.names
      var scopeObj = this
      $scope.imageTags = []

      if (currentItem === 0 && totlaItems > 0) {
        let msg = "Chart is loading, Please Wait for a while"
        let useFullScreen = ($mdMedia('sm') || $mdMedia('xs'));
        $scope.infoMsg = msg;
        $scope.dialogObj = $mdDialog.show({
          template: chartLoaderTemplate,
          clickOutsideToClose: false,
          fullscreen: useFullScreen,
          scope: $scope,
          preserveScope: true
        })
          .then(function (response) {
          }, function (response) {
          })
      } else if (totlaItems == currentItem) {
        $mdDialog.cancel()
      }
      if ($scope.graphdata === undefined)
        return false;
      if (this.chartType === 'Pie' || this.chartType === 'Donut') {
        google.charts.load('current', {
          'packages': ['corechart']
        });
      } else if (this.chartType === 'table') {
        google.charts.load('current', {
          'packages': ['table']
        });
      } else if (this.chartType === 'Histogram' || this.chartType === 'Line' || this.chartType === 'Bar') {
        google.charts.load('current', {
          'packages': ['corechart', 'bar']
        });
      }

      google.charts.setOnLoadCallback(drawChart);

      function drawChart() {
        var dynamicID = $scope.getRandomString();
        var chartdata = undefined;
        chartdata = google.visualization.arrayToDataTable($scope.graphdata);
        let chartHtml = ' </div> <div class="md-whiteframe-3dp" flex id="' + dynamicID + '" flex style="width:' + graphWidth + 'px; height:' + graphHeight + 'px;margin:8px;"></div>';
        var newEle = angular.element(chartHtml);
        var target = document.getElementById('commonchart');
        angular.element(target).append(newEle);
        var options = {
          /*chart: {
            title: 'Company Performance'
          },*/
          title: title,
          bars: 'vertical',
          legend: 'none',
          width: '100%',
          height: '100%',
          chartArea: {
            width: '80%'
          },
          tooltip: {
            isHtml: true,
            textStyle: {
              color: '#0000ff',
              bold: false
            },
            showColorCode: true
          }
        };
        if (graphType === 'Pie') {
          var optionsPie = {
            /*chart: {
              title: 'Company Performance'
            },*/
            width: '50%',
            height: '50%',
            title: title ? title : subTitle ? subTitle : undefined,
            bars: 'vertical',
            chartArea: {
              width: '60%'
            },
            is3D: true,
            /*legend: 'none',*/
            tooltip: {
              isHtml: true,
              textStyle: {
                color: '#0000ff',
                bold: false
              },
              showColorCode: true
            },
            sliceVisibilityThreshold: 0,
            colors: colors ? colors : COMMON_CHART_CONSTANTS.DEFAULT_GRAPH_COLORS
          };
          var chart = new google.visualization.PieChart(document.getElementById(dynamicID));
          //Generating Click event to download PDF
          google.visualization.events.addListener(chart, 'ready', function () {
            var content = '<img src="' + chart.getImageURI() + '">';
            $('#graph-images').append(content);

            if ($scope.imageTags.length === 0) {
              $scope.imageTags.push({
                '_id': dynamicID,
                'image': chart.getImageURI(),
                'width': chart.container.clientWidth,
                'height': chart.container.clientHeight,
                'title': title ? title : subTitle,
                "type": graphType
              })
              scopeObj.setLocalImage({ data: $scope.imageTags })
            } else {
              let isExist = _.find($scope.imageTags, function (img) {
                return img._id == dynamicID
              })
              if (isExist == undefined) {
                $scope.imageTags.push({
                  '_id': dynamicID,
                  'image': chart.getImageURI(),
                  'width': chart.container.clientWidth,
                  'height': chart.container.clientHeight,
                  'title': title ? title : subTitle,
                  "type": graphType
                })
              }
            }
          });
          if (currentItem != totlaItems) {
            optionsPie['width'] = graphWidth
            chart.draw(chartdata, optionsPie);
          } else {
            optionsPie['width'] = graphWidth
            chart.draw(chartdata, optionsPie);
            window.dispatchEvent(new Event('resize'));
            window.addEventListener('resize', function (e) {
              optionsPie['width'] = graphWidth
              chart.draw(chartdata, optionsPie);
            });
          }
        } else if (graphType === 'Bar') {
          let axisTitle = title ? title.split('vs') : axis ? axis.split('vs') : []
          var optionsBar = {
            title: title ? title : subTitle ? subTitle : undefined,
            hAxis: {
              title: axisTitle[0] ? axisTitle[0] : undefined,
              titleTextStyle: {
                color: 'black',
                bold: true,
                italic: false
              },
              textStyle : {
                fontSize: names ? 13 : 16
              }
            },
            vAxis: {
              title: axisTitle[1] ? axisTitle[1].replace(/\(.*\)/, '') : undefined,
              titleTextStyle: {
                color: 'black',
                bold: true,
                italic: false
              }
            },
            /*bar: {
              groupWidth: 20
            },*/
            /*legend: 'none',*/
            legend: { position: 'top', alignment: 'start' },
            width: '100%',
            height: '100%',
            chartArea: {
              top: 50,
              width: '70%'
            },
            tooltip: {
              isHtml: true,
              textStyle: {
                color: '#0000ff',
                bold: false
              },
              showColorCode: true
            },
            animation: {
              duration: 1000,
              easing: 'out'
            },
            bars: 'vertical',
            axes: {
              y: {
                all: {
                  range: {
                    min: 0.010
                  }
                }
              }
            },
            colors: colors ? colors : COMMON_CHART_CONSTANTS.DEFAULT_GRAPH_COLORS
          };
          var chart = new google.visualization.ColumnChart(document.getElementById(dynamicID));
          //Generating Click event to download PDF
          google.visualization.events.addListener(chart, 'ready', function () {
            var content = '<img src="' + chart.getImageURI() + '">';
            $('#graph-images').append(content);

            if ($scope.imageTags.length === 0) {
              $scope.imageTags.push({
                '_id': dynamicID,
                'image': chart.getImageURI(),
                'width': chart.container.clientWidth,
                'height': chart.container.clientHeight,
                'title': title ? title : subTitle,
                "type": graphType
              })
              scopeObj.setLocalImage({ data: $scope.imageTags })
            } else {
              let isExist = _.find($scope.imageTags, function (img) {
                return img._id == dynamicID
              })
              if (isExist == undefined) {
                $scope.imageTags.push({
                  '_id': dynamicID,
                  'image': chart.getImageURI(),
                  'width': chart.container.clientWidth,
                  'height': chart.container.clientHeight,
                  'title': title ? title : subTitle,
                  "type": graphType
                })
              }
            }
          });
          if (currentItem != totlaItems) {
            optionsBar['width'] = graphWidth;
            chart.draw(chartdata, optionsBar);
          } else {
            optionsBar['width'] = graphWidth;
            chart.draw(chartdata, optionsBar);
            window.dispatchEvent(new Event('resize'));
            window.addEventListener('resize', function (e) {
              if (e.currentTarget && e.currentTarget.screen && e.currentTarget.screen.availWidth) {
                optionsBar['width'] = graphWidth;
              }
              chart.draw(chartdata, optionsBar);
            });
          }
        } else if (graphType === 'table') {
          var chart = new google.visualization.Table(document.getElementById(dynamicID));
          chart.draw(chartdata, {
            showRowNumber: true,
            width: '100%',
            height: '100%',
            title: title,
          });
        } else if (graphType === 'Histogram') {
          var optionsHist = {
            title: title,
            width: '100%',
            height: '100%',
            chartArea: {
              width: '80%'
            },
            hAxis: {
              minValue: 0
            },
            vAxis: {},
            legend: 'none',
            bar: {
              groupWidth: '10'
            },
            tooltip: {
              isHtml: true,
              textStyle: {
                color: '#0000ff',
                bold: false
              },
              showColorCode: true
            }
          };
          var chart = new google.visualization.Histogram(document.getElementById(dynamicID));
          if (currentItem != totlaItems) {
            optionsHist['width'] = graphWidth;
            chart.draw(chartdata, optionsHist);
          } else {
            optionsHist['width'] = graphWidth;
            chart.draw(chartdata, optionsHist);
            window.dispatchEvent(new Event('resize'));
            window.addEventListener('resize', function (e) {
              if (e.currentTarget && e.currentTarget.screen && e.currentTarget.screen.availWidth) {
                optionsHist['width'] = graphWidth;
              }
              chart.draw(chartdata, optionsHist);
            });
          }
        } else if (graphType === 'Line') {
          let axisTitle = title ? title.split('vs') : axis ? axis.split('vs') : []
          var optionsLine = {
            title: title ? title : subTitle ? subTitle : undefined,
            hAxis: {
              minValue: 0,
              title: axisTitle[0] ? axisTitle[0] : undefined,
              titleTextStyle: {
                color: 'black',
                bold: true,
                italic: false
              }
            },
            vAxis: {
              title: axisTitle[1] ? axisTitle[1].replace(/\(.*\)/, '') : undefined,
              titleTextStyle: {
                color: 'black',
                bold: true,
                italic: false
              }
            },
            width: '100%',
            height: '100%',
            chartArea: {
              width: '70%'
            },
            /*legend: 'none',*/
            legend: { position: 'top', alignment: 'start' },
            tooltip: {
              isHtml: true,
              textStyle: {
                color: '#0000ff',
                bold: false
              },
              showColorCode: true
            },
            colors: colors ? colors : COMMON_CHART_CONSTANTS.DEFAULT_GRAPH_COLORS
          };
          var chart = new google.visualization.LineChart(document.getElementById(dynamicID));
          //Generating Click event to download PDF
          google.visualization.events.addListener(chart, 'ready', function () {
            var content = '<img src="' + chart.getImageURI() + '">';
            $('#graph-images').append(content);
            if ($scope.imageTags.length === 0) {
              $scope.imageTags.push({
                '_id': dynamicID,
                'image': chart.getImageURI(),
                'width': chart.container.clientWidth,
                'height': chart.container.clientHeight,
                'title': title ? title : subTitle,
                "type": graphType
              })
              scopeObj.setLocalImage({ data: $scope.imageTags })
            } else {
              let isExist = _.find($scope.imageTags, function (img) {
                return img._id == dynamicID
              })
              if (isExist == undefined) {
                $scope.imageTags.push({
                  '_id': dynamicID,
                  'image': chart.getImageURI(),
                  'width': chart.container.clientWidth,
                  'height': chart.container.clientHeight,
                  'title': title ? title : subTitle,
                  "type": graphType
                })
              }
            }
          });
          if (currentItem != totlaItems) {
            optionsLine['width'] = graphWidth;
            chart.draw(chartdata, optionsLine);
          } else {
            optionsLine['width'] = graphWidth;
            chart.draw(chartdata, optionsLine);
            window.dispatchEvent(new Event('resize'));
            window.addEventListener('resize', function (e) {
              if (e.currentTarget && e.currentTarget.screen && e.currentTarget.screen.availWidth) {
                optionsLine['width'] = graphWidth;
              }
              chart.draw(chartdata, optionsLine);
            });
          }
        } else if (graphType === 'Donut') {
          var optionsDonut = {
            title: title ? title : subTitle ? subTitle : undefined,
            pieHole: 0.4,
            //legend: 'none',
            width: '100%',
            height: '100%',
            chartArea: {
              width: '60%'
            },
            tooltip: {
              isHtml: true,
              textStyle: {
                color: '#0000ff',
                bold: false
              },
              showColorCode: true
            },
            sliceVisibilityThreshold: 0,
            colors: colors ? colors : COMMON_CHART_CONSTANTS.DEFAULT_GRAPH_COLORS
          };
          var chart = new google.visualization.PieChart(document.getElementById(dynamicID));
          //Generating Click event to download PDF
          google.visualization.events.addListener(chart, 'ready', function () {
            var content = '<img src="' + chart.getImageURI() + '">';
            $('#graph-images').append(content);
            if ($scope.imageTags.length === 0) {
              $scope.imageTags.push({
                '_id': dynamicID,
                'image': chart.getImageURI(),
                'width': chart.container.clientWidth,
                'height': chart.container.clientHeight,
                'title': title ? title : subTitle,
                "type": graphType
              })
              scopeObj.setLocalImage({ data: $scope.imageTags })
            } else {
              let isExist = _.find($scope.imageTags, function (img) {
                return img._id == dynamicID
              })
              if (isExist == undefined) {
                $scope.imageTags.push({
                  '_id': dynamicID,
                  'image': chart.getImageURI(),
                  'width': chart.container.clientWidth,
                  'height': chart.container.clientHeight,
                  'title': title ? title : subTitle,
                  "type": graphType
                })
              }
            }
          });
          if (currentItem != totlaItems) {
            optionsDonut['width'] = graphWidth;
            chart.draw(chartdata, optionsDonut);
          } else {
            optionsDonut['width'] = graphWidth;
            chart.draw(chartdata, optionsDonut);
            window.dispatchEvent(new Event('resize'));
            window.addEventListener('resize', function (e) {
              if (e.currentTarget && e.currentTarget.screen && e.currentTarget.screen.availWidth) {
                optionsDonut['width'] = graphWidth;
              }
              chart.draw(chartdata, optionsDonut);
            });
          }
        }
      }
    }
  }
}

export default CommonChart


// WEBPACK FOOTER //
// ./src/app/common-chart/controllers/commonChartController.js